export class AppError extends Error {
	public readonly message: string;
	public name: string = 'AppError';
	public readonly description?: string;
	public readonly httpStatus: number;
	public readonly data?: object;

	constructor({
		message,
		httpCode,
		description = '',
		name = 'AppError',
		data,
	}: {
		message: string;
		httpCode: number;
		description?: string;
		name?: string;
		data?: object;
	}) {
		super(message);

		this.message = message;
		this.description = description;
		this.httpStatus = httpCode;
		this.name = name;
		this.data = data;
	}
}
